import { colors, fonts } from '../../../theme';

const footer = {
  position: 'absolute',
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 10,
  display: 'flex',
  flexDirection: 'column',
  // Same insets as the app: the info line ends at the bottom of the actions column.
  gap: '2.6vw',
  pt: '70px',
  pr: '16vw',
  pb: '3vw',
  pl: '2.6vw',
  background: 'linear-gradient(transparent, rgba(0, 0, 0, 0.8))',
  fontFamily: fonts.text,
  color: colors.text,
};

const styles = {
  footer,
  // The TikTok browser on iOS covers the bottom of the page.
  footerTiktok: {
    ...footer,
    pb: 'calc(3vw + 12px)',
  },
  username: {
    fontSize: 15,
    fontWeight: 700,
    lineHeight: 1.3,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  // Closer to the username than to the info line.
  description: {
    mt: 'calc(4px - 2.6vw)',
    fontSize: 13.5,
    lineHeight: 1.35,
    // Long descriptions stop at 2 lines.
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    overflowWrap: 'anywhere',
  },
};

export default styles;
